import CricketBanner from "./CricketBanner/CricketBanner";
import CricketStadium from "./CricketStadium/CricketStadium";


  const CampCricket= () => {
    return <>
      <CricketBanner/>
      <CricketStadium/>
    </>;
  }

  export default CampCricket;